import React, { useEffect, ReactSVG } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Container, Row, Col, Button } from 'reactstrap';
import { isMobile } from 'react-device-detect';
import Config from '../../../Config';
import Lottie from 'react-lottie';
import {
  removeOtpData,
  setSaleActiveStep,
  goToPage,
  returnToLobby,
  saveToHistory,
  setActiveLobbyTab,
  setIsSelectingAccountBusinessIndividual,
  clearSearchParameters,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import './completedWithError.scss';
import { saleActiveStep, customerTypeEnum, lobbyTabsEnum, pages } from '../CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import CallBackComponent from '../CellcomAbroadLobbyBlock/Popups/PopupSharedComponents/CallBackComponent';
import FallingTower from '../../../animations/fallingTower.json';
import {
  gaLoadingErrorPageGeneralError,
  gaGoToStartBusinessIndividual,
  gaCallBackButtonClick,
  gaGoToMyPackageErrorPage,
  gaReturnToAbroadLobbyErrorPage,
  gaLoadingErrorConflictPage,
  gaErrorInstallPackageSeparated,
  gaFailedInstallPackageSeparated,
  gaGoToMarketPlaceFromErrorPage,
  gaExtendedPackagesErrorPage
} from './gaReports';
import { dwhAbroadAddonPackagePage } from './../CellcomAbroadLobbyBlock/dwhReports'
import TowerIcon from './images/towerIcon';
import WorldIcon from './images/worldIcon';
import { getSubscriberDetails, setRetainSubscriberOnLoad } from '../../Page/SelfCarePage/SelfCareSlice';
import ThemedLottie from '../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../utilities/theme/ThemeColorEnum';
const CompletedWithErrorComponent = (props) => {
  const dispatch = useDispatch();
  const shouldDisplayPackageExists =
    (props.data.epiStyleInitializationData.shouldDisplayPackageExists && !props.data.otpData.validatedCostumerData?.isSeparatedSale) ||
    ((props.data.completedWithCode == '39' || props.data.completedWithCode == '96' || props.data.completedWithCode == 'ER006') &&
      props.data.otpData.validatedCostumerData?.isSeparatedSale);
  const isShelfEpiPackage =
    !props.data.abroadPackagesList?.businessIndividual ||
    (props.data.abroadPackagesList?.businessIndividual && props.data.selectedAbroadPackage.isShelfBusinessIndividual);
  const urlToExtendedPackages =
    props.data.otpData?.validatedCostumerData?.accountType == customerTypeEnum.PRIVATE
      ? props.data.epiStyleInitializationData.pageRefToExtendedPackagesPrivate
      : props.data.epiStyleInitializationData.pageRefToExtendedPackagesBusiness;
  const isOverlappingPackage = (props.data.completedWithCode == '39' || props.data.completedWithCode == '96' || props.data.completedWithCode == 'ER006') && props.data.isOverlappingPackage;
  const overlappingText = props.data.completedWithCode == '39' ? 'זיהינו שכבר יש לך חבילה זו ולכן' : 'זיהינו שכבר יש לך חבילה אחרת ולכן';
  const dwhParams = {
    channel: props.data.activeLobbyTab && props.data.activeLobbyTab == 'businessAccount' ? 'WebsiteBusiness' : 'WebsitePrivate',
    param1: props.data.isJETAuthentication ? 'JET' : 'WEBSITE',
    param2: props.data.selectedAbroadPackage.socCode,
    actionType: "Addon Package Message",
    costumerName: props.userData?.firstName + ' ' + props.userData?.lastName,
    idNumber: props.userData?.IDNumber,
    subscriber: props.mobile,
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
    props.saveToHistory('abroadFailure');
    gaOnLoadErrorPage();
    if (urlToExtendedPackages && isOverlappingPackage) {
      gaExtendedPackagesErrorPage(overlappingText);
      dwhAbroadAddonPackagePage({ message: 'Addon Package Message Displayed', ...dwhParams });
    }
  }, []);


  let title = getTitle();
  let text = getText();
  function gaOnLoadErrorPage() {
    switch (props.data.completedWithCode) {
      case '96':
      case 'ER006':
        if (props.data.otpData.validatedCostumerData?.isSeparatedSale) {
          gaFailedInstallPackageSeparated();
        } else {
          gaLoadingErrorConflictPage(
            props.businessOrPrivate,
            props.data.startedFromPackage,
            props.data.epiStyleInitializationData.businessIndividualLobby,
            props.data.completedWithCode
          );
        }
        break;
      case '39':
        if (props.data.otpData.validatedCostumerData?.isSeparatedSale) {
          gaErrorInstallPackageSeparated();
        } else {
          gaLoadingErrorConflictPage(
            props.businessOrPrivate,
            props.data.startedFromPackage,
            props.data.epiStyleInitializationData.businessIndividualLobby,
            props.data.completedWithCode
          );
        }
        break;
      case 'Roam':
        if (props.data.otpData.validatedCostumerData?.isSeparatedSale) {
          gaErrorInstallPackageSeparated();
        }
        break;
      default:
        if (props.data.otpData.validatedCostumerData?.isSeparatedSale) {
          gaErrorInstallPackageSeparated();
        } else {
          gaLoadingErrorPageGeneralError(
            props.businessOrPrivate,
            props.data.startedFromPackage,
            props.data.epiStyleInitializationData.businessIndividualLobby
          );
        }
        break;
    }
  }


  function getTitle() {
    let title = 'רק רגע, משהו לא הסתדר פה';

    switch (props.data.completedWithCode) {
      case '96':
      case 'ER006':
        title = 'לא הצלחנו להתקין את החבילה';
        break;
      case '39':
        title = 'החבילה כבר מותקנת';
        break;
      case 'Roam':
      case 'NoRoam':
        title = 'רק רגע, יש פה עניין';
        break;
      default:
        break;
    }
    if (props.data.otpData.validatedCostumerData?.isSeparatedSale && props.data.completedWithCode == 'Shadow') {
      title = 'לא הצלחנו להתקין את החבילה';
    }
    return title;
  }

  function getText() {
    let text;
    if (props.data.epiStyleInitializationData.businessIndividualLobby) {
      text = `אל דאגה, צוות המומחים שלנו  זמין  כדי לטפל בכל בעיה`;
    } else {
      if (!isShelfEpiPackage) {
        text = 'אפשר לנסות שוב או לפנות לאיש הקשר בארגונך';
      } else {
        text = `אפשר לנסות שוב או להתקשר אלינו`;
      }
    }

    if (props.data.otpData.validatedCostumerData?.isSeparatedSale) {
      switch (props.data.completedWithCode) {
        case '96':
        case 'ER006':
          text = `כי אנחנו רואים שיש לך חבילת חו"ל אחרת.<br/> מזכירים לך שבכל רגע ניתן לצפות <br/> במצב ניצול החבילה`;
          break;
        case '39':
          text = `זיהינו שחבילה זו כבר קיימת.<br/> מזכירים לך שבכל רגע ניתן לצפות <br/> במצב ניצול החבילה`;
          break;
        case 'CLIENT':
          text = 'אפשר לנסות שוב בעוד מספר דקות<br/>(18)';
          break;
        default:
          text = 'אפשר לנסות שוב בעוד מספר דקות<br/>(15)';
          break;
      }
    } else {
      switch (props.data.completedWithCode) {
        case '96':
        case 'ER006':
          text = props.data.epiStyleInitializationData.businessIndividualLobby
            ? `זיהינו שלמנוי יש כבר חבילה אחרת. <br/>  מזכירים לך שבכל רגע ניתן לצפות <br/> במצב ניצול החבילה`
            : `כי אנחנו רואים שיש לך חבילת חו"ל אחרת.<br/> מזכירים לך שבכל רגע ניתן לצפות <br/> במצב ניצול החבילה`;
          break;
        case '39':
          text = 'מזכירים לך שבכל רגע ניתן לצפות  <br /> במצב ניצול החבילה';
          break;
        case 'Shadow':
          text = 'זיהינו שלמנוי יש כבר חבילה אחרת שהוא התקין בהפרדה';
          break;
        default:
          if (props.data.completedWithCode == 'Roam' || props.data.completedWithCode == 'NoRoam') {
            text = 'המינוי פתוח לתקשורת רק בארץ, ולכן אי <br/> אפשר לרכוש עבורו חבילת חו"ל';
          }
          break;
      }
    }
    return text;
  }

  const returnToAbroadLobby = () => {
    gaReturnToAbroadLobbyErrorPage(
      props.businessOrPrivate,
      props.data.completedWithCode,
      props.data.startedFromPackage,
      props.data.otpData.validatedCostumerData?.isSeparatedSale
    );
    props.setSaleActiveStep(saleActiveStep.LOADER);
    if (props.data.isRegularAbroadCustomer) {
      goToSelfCareAbroadCustomer();
    } else {
      props.returnToLobby();
      props.context.navigateTo(props.data.epiStyleInitializationData.currentLobbyPath);
    }
  };

  const goToStartBusinessIndividual = async () => {
    gaGoToStartBusinessIndividual(props.data.completedWithCode);
    let params = {
      isSelecting: false,
      removeSelectedAbroadPackage: true,
      abroadLobbyActiveStep: pages.LOBBY,
    };
    props.clearSearchParameters();
    props.setIsSelectingAccountBusinessIndividual(params);
  };

  const gaReportCallbackClick = () => {
    gaCallBackButtonClick(
      props.businessOrPrivate,
      props.data.completedWithCode,
      props.data.startedFromPackage,
      props.data.epiStyleInitializationData.businessIndividualLobby,
      props.data.otpData.validatedCostumerData?.isSeparatedSale,
      isOverlappingPackage,
      overlappingText
    );
    if (isOverlappingPackage) {
      dwhAbroadAddonPackagePage({ message: 'Call to Service Button Clicked', ...dwhParams })
    }
  };

  const goToSelfCareAbroadCustomer = async () => {
    props.setSaleActiveStep(saleActiveStep.LOADER);
    await dispatch(setRetainSubscriberOnLoad(true));
    await dispatch(getSubscriberDetails(props?.data?.otpData?.otpPhone));
    props.context.navigateTo(props?.LinkForAbroadSelfCare?.value?.url);
  }

  function goToMyPackage() {
    gaGoToMyPackageErrorPage(
      props.businessOrPrivate,
      props.data.startedFromPackage,
      props.data.otpData.validatedCostumerData?.isSeparatedSale,
      props.data.epiStyleInitializationData.businessIndividualLobby,
      props.data.completedWithCode,
      isOverlappingPackage,
      overlappingText
    );

    if (props.data.epiStyleInitializationData.businessIndividualLobby) {
      const activeTab = lobbyTabsEnum.PACKAGEEXISTS_BUSINESSINDIVIDUAL;
      props.setSaleActiveStep(saleActiveStep.LOADER);
      props.setActiveLobbyTab(activeTab);
      props.returnToLobby({ activeTab: activeTab });
      props.context.navigateTo(props.data.epiStyleInitializationData.currentLobbyPath);
    } else {
      goToSelfCareAbroadCustomer();
    }

    if (urlToExtendedPackages) {
      dwhAbroadAddonPackagePage({ message: 'Usage Check Button Clicked', ...dwhParams });
    }
  }

  function goToMarketPlace() {
    if (urlToExtendedPackages) {
      gaGoToMarketPlaceFromErrorPage(overlappingText)
      dwhAbroadAddonPackagePage({ message: 'Addon Package Button Clicked', ...dwhParams });
      props.context.navigateTo(urlToExtendedPackages);
    }
  }

  const handleButtonPackages = () => {
    if (props.data.isRegularAbroadCustomer) {
      return (
        <Button color='link' onClick={() => goToSelfCareAbroadCustomer()}>
          <span className='btn-submit__label newPurple underline'> {"באזור האישי"}</span>
        </Button>
      )
    } else {
      return (
        <Button color='link' onClick={() => goToMyPackage()}>
          <span className='btn-submit__label newPurple underline'> {`באזור חו"ל שלי `}</span>
        </Button>
      )
    }
  }

  function getSVG() {
    if (isOverlappingPackage) {
      return <WorldIcon />;
    }
    else if (props.data.completedWithCode == 'Roam' ||
      props.data.completedWithCode == 'NoRoam' ||
      (props.data.otpData.validatedCostumerData?.isSeparatedSale && !isOverlappingPackage)) {
      return <TowerIcon />;
    }
    return <ThemedLottie animationData={FallingTower} color={ThemeColorEnum.PRIMARY} width={125} height={125} loop={false} autoplay={true} />;
  }

  function getCallback() {
    if (props.data.otpData.validatedCostumerData?.isSeparatedSale || !isShelfEpiPackage) {
      return null;
    } else {
      return (
        <Row>
          <CallBackComponent onclick={gaReportCallbackClick} isSeparatedSale={props.data.otpData.validatedCostumerData?.isSeparatedSale} />
        </Row>
      );
    }
  }

  return (
    <Container className='completed-with-error-wrapper'>
      <Row>
        <Col className='error-image text-center'>{getSVG()}</Col>
      </Row>
      {(!isOverlappingPackage || !urlToExtendedPackages) && (
        <Row>
          <Col className='completed-with-error-title text-center'>
            <span className=' d-block bold mr-auto ml-auto mt-35' dangerouslySetInnerHTML={{ __html: title }} />
          </Col>
        </Row>
      )}
      {/* link to extended packages */}
      {urlToExtendedPackages && isOverlappingPackage ? (
        <>
          {' '}
          <Row>
            <Col className='completed-with-error-text mb-15'>
              <Row>
                <span
                  className={` ${isMobile ? 'd-block' : ''} mr-auto ml-auto normal-text`}
                  dangerouslySetInnerHTML={{ __html: overlappingText }}
                />
              </Row>

              <Row>
                <span className='large-text'>אתם זכאים לחבילת המשך משתלמת!</span>
              </Row>
              <button className='btn-submit' onClick={() => goToMarketPlace()}>
                <span className='btn-submit__label'>לרכישת חבילות המשך </span>
              </button>
            </Col>
          </Row>
          {shouldDisplayPackageExists === true && isShelfEpiPackage && (
            <Row>
              <Col className='completed-with-error-text h-40'>
                <span
                  className={`mr-auto ml-auto small-text`}
                  dangerouslySetInnerHTML={{ __html: 'מזכירים לך שבכל רגע ניתן לצפות <br/> במצב ניצול החבילה' }}
                />
                {handleButtonPackages()}
              </Col>
            </Row>
          )}
        </>
      ) : (
        <Row>
          <Col className='completed-with-error-text h-40'>
            <span className={`mr-auto ml-auto small-text`} dangerouslySetInnerHTML={{ __html: text }} />
            {shouldDisplayPackageExists === true && isShelfEpiPackage && handleButtonPackages()}
          </Col>
        </Row>
      )}

      {getCallback()}
      <Row>
        <Col className='text-center return-to-lobby-button'>
          <BtnSubmit
            text={'סיום'}
            onclick={props.data.epiStyleInitializationData.businessIndividualLobby ? goToStartBusinessIndividual : returnToAbroadLobby}
          />
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  data: state.cellcomAbroad,
  userData: state.authentication?.loginData?.userDetails,
  mobile: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby
    ? state.cellcomAbroad.businessIndividualData.selectedAccountNumber
    : state.cellcomAbroad.otpData.otpPhone || state.authentication.loginData.userDetails.contactNumber,
});

const mapDispatchToProps = {
  removeOtpData,
  saveToHistory,
  setSaleActiveStep,
  goToPage,
  returnToLobby,
  setActiveLobbyTab,
  setIsSelectingAccountBusinessIndividual,
  clearSearchParameters,
  setRetainSubscriberOnLoad,
  getSubscriberDetails
};

export default connect(mapStateToProps, mapDispatchToProps)(CompletedWithErrorComponent);
